/**
 * @fileoverview Cost Management Admin Page (MOR-735)
 *
 * Purpose: Owner-only billing dashboard — vendor costs (Anthropic, OpenAI,
 * Reducto, InfoTrack) attributed to organisations, jobs and pipeline stages,
 * with margin estimates and the affiliate rev-share toggle.
 * URL: /admin/cost-management
 * Protection: owner-only (super_admin + owner allowlist). Never expose any
 * of this data to firm users.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@cvx/_generated/api";
import { CostManagementView } from "@/components/admin/cost-management/CostManagementView";

export const Route = createFileRoute(
  "/_app/_auth/admin/_layout/cost-management",
)({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(
      convexQuery(api.users.queries.getCurrentUser, {}),
    );
    if (!user?.isOwner) {
      throw redirect({ to: "/admin/master-library" });
    }
  },
  component: CostManagementPage,
});

function CostManagementPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-semibold">Cost Management</h1>
        <p className="text-sm text-muted-foreground">
          Vendor costs, margins and rev-share across every organisation and job.
          Internal billing view — never visible to firms.
        </p>
      </div>
      <CostManagementView />
    </div>
  );
}
